// services/utils.js

export class OrderStatus {
  static readonly pendingPayment = 0;
  static readonly pendingShipment = 1;
  static readonly shipped = 2;
  static readonly outForDelivery = 3;
  static readonly delivered = 4;
  static readonly completed = 5;
  static readonly closed = 6;
  static readonly invalidOrder = 7;

  static getDescription(status: number, statusType: number): string {
    if (statusType === OrderStatusType.DELIVERY) {
      switch (status) {
        case OrderStatus.pendingPayment:
          return 'Pending Payment';
        case OrderStatus.pendingShipment:
          return 'Pending Shipment';
        case OrderStatus.shipped:
          return 'Shipped';
        case OrderStatus.delivered:
          return 'Delivered';
        case OrderStatus.completed:
          return 'Completed';
        case OrderStatus.closed:
          return 'Closed';
        case OrderStatus.invalidOrder:
          return 'Invalid Order';
        default:
          return 'Unknown Status';
      }
    } else {
      switch (status) {
        case ReturnStatus.RETURN_INITIATED:
          return 'Return Initiated';
        case ReturnStatus.RETURN_APPROVED:
          return 'Return Approved';
        case ReturnStatus.RETURN_PICKUP:
          return 'Return Pickup';
        case ReturnStatus.REFUND:
          return 'Refund';
        case ReturnStatus.RETURN_REJECTED:
          return 'Return Rejected';
        case ReturnStatus.RETURN_CANCELLED:
          return 'Return Cancelled';
        default:
          return 'Unknown Status';
      }
    }
  }
}

export enum OrderStatusType {
  DELIVERY = 0,
  RETURN = 1,
  EXCHANGE = 2
}


export class OrderStatusTypeHelper {
  static getDescription(status: OrderStatusType): string {
    switch (status) {
      case OrderStatusType.DELIVERY:
        return 'delivery';
      case OrderStatusType.RETURN:
        return 'return';
      case OrderStatusType.EXCHANGE:
        return 'exchange';
      default:
        throw new Error('Invalid order status');
    }
  }
}


export function getDescriptionTextForDate(status: number, statusType: OrderStatusType): string {
  if (statusType === OrderStatusType.DELIVERY) {
    switch (status) {
      case OrderStatus.pendingPayment:
        return '';
      case OrderStatus.pendingShipment:
        return 'expected shipment on';
      case OrderStatus.shipped:
      case OrderStatus.outForDelivery:
        return 'expected delivery on';
      case OrderStatus.delivered:
      case OrderStatus.completed:
      case OrderStatus.closed:
        return 'on';
      case OrderStatus.invalidOrder:
        return 'Invalid Order';
      default:
        return 'Unknown Status';
    }
  } else {
    switch (status) {
      case ReturnStatus.RETURN_INITIATED:
      case ReturnStatus.RETURN_APPROVED:
      case ReturnStatus.RETURN_PICKUP:
      case ReturnStatus.REFUND:
      case ReturnStatus.RETURN_REJECTED:
      case ReturnStatus.RETURN_CANCELLED:
        return 'on';
      default:
        return 'Unknown Status';
    }
  }
}

export enum ReturnStatus {
  RETURN_INITIATED = 0,
  RETURN_APPROVED = 1,
  RETURN_PICKUP = 2,
  REFUND = 3,
  RETURN_REJECTED = 4,
  RETURN_CANCELLED = 5
}

export class ReturnStatusHelper {
  static getDescription(status: ReturnStatus): string {
    switch (status) {
      case ReturnStatus.RETURN_INITIATED:
        return 'Return Initiated';
      case ReturnStatus.RETURN_APPROVED:
        return 'Return Approved';
      case ReturnStatus.RETURN_PICKUP:
        return 'Return Pickup';
      case ReturnStatus.REFUND:
        return 'Refund';
      case ReturnStatus.RETURN_REJECTED:
        return 'Return Rejected';
      case ReturnStatus.RETURN_CANCELLED:
        return 'Return Cancelled';
      default:
        throw new Error('Invalid return status');
    }
  }
}


export enum ExchangeStatus {
  EXCHANGE_INITIATED = 0,
  EXCHANGE_APPROVED = 1,
  RETURN_PICKUP = 2,
  EXCHANGE_COMPLETE = 3,
  EXCHANGE_REJECTED = 4
}

export class ExchangeStatusHelper {
  static getDescription(status: ExchangeStatus): string {
    switch (status) {
      case ExchangeStatus.EXCHANGE_INITIATED:
        return 'Exchange Initiated';
      case ExchangeStatus.EXCHANGE_APPROVED:
        return 'Exchange Approved';
      case ExchangeStatus.RETURN_PICKUP:
        return 'Return Pickup';
      case ExchangeStatus.EXCHANGE_COMPLETE:
        return 'Exchange Complete';
      case ExchangeStatus.EXCHANGE_REJECTED:
        return 'Exchange Rejected';
      default:
        throw new Error('Invalid exchange status');
    }
  }
}